import * as moment from 'moment';
import { IWatrRequestTravels } from '@nkr/models/index';
import { Utility } from '@nkr/services/utility';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import { FileDocumentType } from '@nkr/enums/index';
import { useContext } from 'react';
import { DonorShieldContext } from '../context';

interface IProps {
    id: number,
    firstName: string,
    lastName: string,
    hasSelfEmployed: boolean,
    travelAffidavits: IWatrRequestTravels[]
}

const Affirmations = (props: IProps) => {
    const context = useContext(DonorShieldContext);

    const downloadFile = (docType: FileDocumentType, lookupId: number) => {
        context.downloadFile(docType, lookupId)
            .then((response: any) => {

                let fileName = props.firstName + '_' + props.lastName
                    + "_" + FileDocumentType[docType].toString()
                    + "_" + moment().format("YYYY_MM_DD");

                downloadFile(response.data, response.data.type);
            });
    };

    return (
        <Panel eventKey='6'>
            <Panel.Heading style={{ paddingTop: 5, paddingBottom: 5 }}>
                <Panel.Title toggle style={{ fontSize: 14 }}>Affirmations</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
                <ListGroup>
                    {props.travelAffidavits.length > 0 && (
                        <ListGroupItem header='Travel'>
                            {props.travelAffidavits.map((x, index) => {
                                let hasDependentCare = x.dependentCareFile != null && x.dependentCareFile != '';
                                let hasDependentCompanion = x.dependentCompanionFile != null && x.dependentCompanionFile != '';
                                let hasPaymentAssistance = x.paymentAssistanceFile != null && x.paymentAssistanceFile != '';

                                return (
                                    <div style={{ display: 'flex', alignItems: 'top', paddingTop: index > 0 ? 10 : 0 }}>
                                        <div style={{ marginRight: 10, paddingTop: 7 }}><strong>{Utility.getOrdinalSuffixOfDate(x.createdDateTime)}</strong></div>

                                        <div style={{ width: '75%' }}>
                                            {hasDependentCare && (
                                                <span style={{ paddingRight: 20 }}>
                                                    <a className='btn btn-default'
                                                        onClick={() => downloadFile(FileDocumentType.DsDependentCare, x.id)}>
                                                        Dependent Care File
                                                    </a>
                                                </span>
                                            )}

                                            {hasDependentCompanion && (
                                                <span style={{ paddingRight: 20 }}>
                                                    <a className='btn btn-default'
                                                        onClick={() => downloadFile(FileDocumentType.DsDependentCompanion, x.id)}>
                                                        Dependent Companion File
                                                    </a>
                                                </span>
                                            )}

                                            {hasPaymentAssistance && (
                                                <span>
                                                    <a className='btn btn-default'
                                                        onClick={() => downloadFile(FileDocumentType.DsPaymentAssistance, x.id)}>
                                                        Payment Assistance File
                                                    </a>
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </ListGroupItem>
                    )}

                    {props.hasSelfEmployed && (
                        <ListGroupItem header='Self Employed'>
                            <div>
                                <a className='btn btn-default form-control'
                                    onClick={() => downloadFile(FileDocumentType.DsSelfEmployedAffidavit, props.id)}>
                                    Self-Employed Affirmation
                                </a>
                            </div>
                        </ListGroupItem>
                    )}
                </ListGroup>
            </Panel.Body>
        </Panel>
    )
}

export default Affirmations;